import React from "react";
import BrandingPane from "@/components/BrandingPane";
import { ReleaseNotes } from "@/app/ReleaseNotes";

/**
 * Operations Desk auth shell.
 * Left: graphite branding (hidden on mobile).
 * Right: white form pane.
 */
export default function AuthLayout({ children, eyebrow, title, subtitle }) {
  return (
    <div className="min-h-screen w-full bg-[var(--phx-brand-canvas)] lg:grid lg:grid-cols-[minmax(0,.85fr)_minmax(440px,1.15fr)]">
      <BrandingPane />
      <main className="flex min-h-screen flex-col justify-center bg-white px-5 py-8 sm:px-8 lg:px-12">
        <div className="mx-auto w-full max-w-md">
          {eyebrow && (
            <p
              data-testid="auth-eyebrow"
              className="mb-3 text-sm font-semibold text-[var(--phx-brand-primary)]"
            >
              {eyebrow}
            </p>
          )}
          <h2
            data-testid="auth-title"
            className="text-2xl font-semibold tracking-tight text-[var(--phx-brand-ink)] sm:text-3xl"
          >
            {title}
          </h2>
          {subtitle && (
            <p className="mt-3 text-sm leading-6 text-slate-600">
              {subtitle}
            </p>
          )}
          <div className="mt-6">{children}</div><div className="mt-6"><ReleaseNotes /></div>
        </div>
      </main>
    </div>
  );
}

